module.exports = __webpack_public_path__ + "img/LUB00147.e57d955f.png";